// CarCards.tsx
// CarCards.tsx
import React from "react";
import "./CarCards.scss";
import { Pagination } from "antd";

// Local type for the car data
interface Car {
  key: string;
  name: string;
  image: string;
  location?: string;
  url?: string;
}

const Tags = [
  "Inventory Gap",
  "High Demand",
  "CRM Match",
  "Past Sales Match"
]

interface CarCardProps {
  page?: number;
  itemsPerPage?: number;
  dataSource: Array<Car>;
  carsLength?: number;
  onPageChange?: (page: number) => void;
  onNavigateToDetails?: () => void; // Make optional
  onCardClick?: (car: Car) => void; // Add this
  pages: boolean; // Determines if pagination should be shown
  selectedKey?: string | null; // Add this
}

const CarCards: React.FC<CarCardProps> = ({
  page,
  itemsPerPage,
  dataSource,
  carsLength,
  onPageChange,
  onNavigateToDetails,
  onCardClick, // Add this
  pages, // Destructure the 'pages' prop
  selectedKey,
}) => {

  const getDomainFromUrl = (url?: string): string => {
    if (!url) return '';
    try {
      const domain = new URL(url).hostname;
      return domain.replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  };

  const getDeterministicTag = (car: Car): string => {
    const source = car.location || car.name || "";
    let sum = 0;
    for (let i = 0; i < source.length; i++) {
      sum += source.charCodeAt(i);
    }
    const index = sum % Tags.length;
    return Tags[index];
  };

  const handleTableChange = (pagination: number) => {
    if (onPageChange) {
      onPageChange(pagination); // Notify parent component of page change
    }
  };

  const handleCardClick = (car: Car) => {
    if (onCardClick) {
      onCardClick(car);
    } else if (onNavigateToDetails) {
      onNavigateToDetails();
      // Fallback navigation logic can be added here if needed
    }
  };

  return (
    <div className="car-cards-container">
      {dataSource.map((car) => (
        <div
          className={`car-card ${car.key === selectedKey ? 'selected' : ''}`}
          key={car.key}
          onClick={() => handleCardClick(car)}
          style={{ cursor: 'pointer' }}
        >
          <div className="image-container">
            {/* <div className="website-tag">{getDeterministicTag(car)}</div> */}
            <img src={car.image} alt={car.name} />
          </div>
          <div className="car-details">
            <div className="name-row">
              <h3 className="car-name">{car.name}</h3>
            </div>
            {car.location && <p className="car-location">Location: {car.location}</p>}
          </div>
        </div>
      ))}
      {/* Conditionally render Pagination if 'pages' is true */}
      {pages && (
        <Pagination
          className="custom-pagination"
          current={page}
          pageSize={itemsPerPage}
          total={carsLength}
          onChange={handleTableChange}
          showSizeChanger={false}
        />
      )}
    </div>
  );
};

export default CarCards;